import { useLocation } from 'react-router-dom';

import { SingleEvent } from './SingleEvent';

export const SingleEventContainer = () => {
  const { state } = useLocation();
  return <SingleEvent institutionData={state} />;
};
